import React, { FC, Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { SCHEDULE_LIST_TITLE } from '../../constants/calendar/scheduleList'
import useFilterSchedules from '../../hooks/useFilterSchedules'
import usePendingSchedules from '../../hooks/usePendingSchedules'
import { useModal } from 'react-hooks-use-modal'
import { FormInput, FormLabel, FormLabelInputWrapper, LoadingContainer, ModalClose, ModalForm, ModalStyle, ModalSubmit, ModalTitle } from 'styles/styles'
import { CircularProgress } from '@mui/material'
import SubmitPerformances from 'components/SubmitPerformances'
import { useForm, SubmitHandler } from "react-hook-form"
import { Time, removeKeyWithValue } from 'utils'
import axios from 'axios'
import { useAuth } from 'hooks/use-auth'
import { mutate } from 'swr'
import { useCalendarContext } from 'Calendar/context/calendar'
import config from 'config'
import IdSearchButton from 'components/IdSearchButton'

interface ParentDataProps {
  records_process_id: number
  records_product_number_id: number
  process_id: number
  process_display_id: string
  process_name: string
  equipment_id: number
  equipment_display_id: string
  equipment_name: string
  charged_user_id: number
  charged_user_display_id: string
  charged_user_name: string
  volume: string
  setup_time: string
  tact_time: string
  start_date: string
  end_date: string
  estimated_time: number
  process_deadline: string
  memo: string
  [key: string]: string | number | boolean;
}

const ScheduleList: FC = () => {
  const { pendingSchedules } = usePendingSchedules()
  const [searchText, setSearchText] = useState('')
  const filtered = useFilterSchedules(pendingSchedules || [], searchText)
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  const { date, } = useCalendarContext()
  const [selectedCalendarData, setSelectedCalendarData] = useState<any>([])
  const [isDrag, setIsDrag] = useState(false)

  const auth = useAuth();
  //modal
  const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
  const { reset, register, handleSubmit, setValue, watch, formState: { errors } } = useForm<ParentDataProps>();
  const onSubmit: SubmitHandler<ParentDataProps> = async (submitData: ParentDataProps) => {
    let alertList: any[] = [];
    const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined) {
        alertList.push(key)
      }
    });
    if (alertList.length) {
      let text = '';
      parentArray.forEach(item => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== '') {
        alert(text);
        throw new Error('必須項目が未入力です');
      }
    }
    if (submitData.start_date > submitData.end_date) {
      window.alert("開始時刻は終了時刻より前にしてください");
      throw new Error('開始時刻は終了時刻より前にしてください');
    }
    /* submitDataで日付の部分がnullだと、仕様で文字列になってしまうため、対応 */
    if (submitData.start_date === "NaN-aN-aNTaN:aN") {
      submitData.start_date = "";
    }
    if (submitData.end_date === "NaN-aN-aNTaN:aN") {
      submitData.end_date = "";
    }
    /* ここまで */


    submitData = removeKeyWithValue(submitData, '');
    const branchData = {
      is_ended: submitData.is_ended,
      process_id: submitData.process_id,
      process_display_id: submitData.process_display_id,
      process_name: submitData.process_name,
      equipment_id: submitData.equipment_id,
      equipment_display_id: submitData.equipment_display_id,
      equipment_name: submitData.equipment_name,
      charged_user_id: submitData.charged_user_id,
      charged_user_display_id: submitData.charged_user_display_id,
      charged_user_name: submitData.charged_user_name,
      volume: submitData.volume,
      setup_time: submitData.setup_time,
      tact_time: submitData.tact_time,
      start_date: submitData.start_date ? new Date(submitData.start_date).toISOString() : undefined,
      end_date: submitData.end_date ? new Date(submitData.end_date).toISOString() : undefined,
      estimated_time: submitData.estimated_time,
      process_deadline: submitData.process_deadline,
      memo: submitData.memo,
    }
    try {
      setIsSubmitDisable(true);
      await axios.patch(`/v0/records-product-numbers/${submitData.records_product_number_id}/records-processes`, branchData, {
        headers: auth.authorizationHeader,
        params: {
          selected_branch: submitData.records_process_id,
          factory_id: auth.factoryId
        }
      })
      window.alert("変更が完了しました");
      mutate(['/api/schedules', date, filtered])
      close();
    } catch (error) {
      window.alert("エラーが発生し、変更に失敗しました");
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成

  const parentArray = [
    { title: '', field: 'records_product_number_id' },
    { title: '', field: 'records_process_id' },
    { title: '作業区分', field: 'status', disable: true },
    { title: '終了フラグ', field: 'is_ended', type: 'checkbox' },
    { title: '', field: 'process_id' },
    { title: '工程ID', field: 'process_display_id', type: 'alphanumeric', required: true, disable: true },
    { title: '工程名称', field: 'process_name', search: 'processes', required: true, disable: true },
    { title: '', field: 'equipment_id' },
    { title: '設備ID', field: 'equipment_display_id', disable: true },
    { title: '設備名称', field: 'equipment_name', search: 'equipments', disable: true },
    { title: '', field: 'charged_user_id' },
    { title: '担当者ID', field: 'charged_user_display_id', disable: true, required: true },
    { title: '担当者名', field: 'charged_user_name', disable: true, required: true, search: "users" },
    { title: '製作数量', field: 'volume', default: 0, type: 'number' },
    { title: '段取時間(分)', field: 'setup_time', type: 'number' },
    { title: 'タクトタイム(分)', field: 'tact_time', type: 'number' },
    { title: '工程開始時刻', field: 'start_date', type: 'datetime-local' },
    { title: '工程終了時刻', field: 'end_date', type: 'datetime-local' },
    { title: '計画加工時間(分)', field: 'estimated_time', type: 'number', required: true },
    { title: '工程納期', field: 'process_deadline', default: Time.format(new Date(), "YYYY-MM-DD"), type: 'date' },
    { title: '共有したか否か', field: 'is_outsourcing', type: 'checkbox', disable: true },
    { title: 'メモ', field: 'memo', default: 'メモ', type: 'text' }
  ]
  const columnsArray: any = [];
  for (const element of parentArray) {
    if (element.title) {
      columnsArray.push({
        title: element.title,
        field: element.field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      })
    }
  }
  const [selectedProcessContents, setSelectedProcessContents] = useState<any>('');
  const [selectedEquipmentContents, setSelectedEquipmentContents] = useState<any>('');
  const [selectedUserContents, setSelectedUserContents] = useState<any>('');

  const listItems = parentArray.map((element: any, index) => {
    if (element.title) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput {...register(element.field)}
              {...(element.type && { type: config.inputErrorMessage[element.type].type })}
              {...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
              {...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
              {...(element.type && { title: config.inputErrorMessage[element.type].title })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
              {...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
              {...(element.field.includes("branch") && { max: 99 })}
            />
            {element.search === "equipments" ? <IdSearchButton search={element.search} setSelectedContents={setSelectedEquipmentContents} /> :
              element.search === "processes" ? <IdSearchButton search={element.search} setSelectedContents={setSelectedProcessContents} /> :
                element.search === "users" ? <IdSearchButton search={element.search} setSelectedContents={setSelectedUserContents} /> : <></>
            }
          </FormLabelInputWrapper>
        </Fragment>
      )
    }
  });

  useEffect(() => {
    setValue('process_id', selectedProcessContents.process_id);
    setValue('process_display_id', selectedProcessContents.display_id);
    setValue('process_name', selectedProcessContents.name);
  }, [selectedProcessContents])

  useEffect(() => {
    setValue('equipment_id', selectedEquipmentContents.equipment_id);
    setValue('equipment_display_id', selectedEquipmentContents.display_id);
    setValue('equipment_name', selectedEquipmentContents.name);
  }, [selectedEquipmentContents])

  useEffect(() => {
    setValue('charged_user_id', selectedUserContents.user_id);
    setValue('charged_user_display_id', selectedUserContents.display_id);
    setValue('charged_user_name', selectedUserContents.name);
  }, [selectedUserContents])

  async function handleScheduleMouseUp(id: string) {
    if (isDrag) {
      return
    }
    const result: any = await axios.get(`/v0/factories/${auth.factoryId}/records-processes`, {
      headers: auth.authorizationHeader,
      params: { id: id }
    });
    result.data[0].end_date = Time.utcToHtmlDatetimeLocal(result.data[0].end_date);
    result.data[0].start_date = Time.utcToHtmlDatetimeLocal(result.data[0].start_date);
    result.data[0].is_outsourcing = parseInt(result.data[0].is_outsourcing);
    setSelectedCalendarData(result.data[0])
    reset(result.data[0]);
    open();
  }


  return (
    <ScheduleListWrapper>
      <ScheduleListTitle>{SCHEDULE_LIST_TITLE}</ScheduleListTitle>
      <ScheduleListInput
        type="text"
        placeholder="キーワード検索"
        value={searchText}
        onChange={({ target }) => setSearchText(target.value)}
      />
      <ScheduleWrapper>
        {filtered.map((schedule) => {
          return (
            <Schedule
              key={schedule.id}
              data-id={schedule.id}
              draggable
              color={schedule.color}
              onDragStart={(event) => {
                if (event.currentTarget.dataset.id) {
                  event.dataTransfer.setData('Text', event.currentTarget.dataset.id)
                }
              }}
              onMouseUp={() => handleScheduleMouseUp(schedule.id)}
              onMouseDown={() => {
                setIsDrag(false)
              }}
              onMouseMove={() => {
                setIsDrag(true)
              }}
            >
              <span style={{ color: schedule.color }}>●&nbsp;</span>
              <span style={{ color: schedule.color }}>{schedule.name}</span>
            </Schedule>
          )
        })}
        <Modal>
          <ModalStyle>
            <ModalTitle>工程計画詳細</ModalTitle>
            <ModalForm onSubmit={handleSubmit(onSubmit)}>
              {listItems}
              {isSubmitDisable ? (
                <LoadingContainer>
                  <CircularProgress size={20} />
                </LoadingContainer>
              ) : (
                <ModalSubmit type="submit" disabled={isSubmitDisable} />
              )}
            </ModalForm>
            <ModalClose onClick={close}>CLOSE</ModalClose>
            {(selectedCalendarData.is_ended === 0 && selectedCalendarData.status !== "未計画") && <SubmitPerformances selectedData={selectedCalendarData} type={"button"} parentClose={close} />}
          </ModalStyle>
        </Modal>
      </ScheduleWrapper>
    </ScheduleListWrapper>
  )
}

export default ScheduleList

const Schedule = styled.div`
  cursor: pointer;

  padding: 2px 6px;
  font-family: Inter;
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 0em;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;

  border-left: solid 3px ${({ color }) => color};
  border-radius: 4px;

  width: 94%;
  height: 100%;
  height: 68px;
  background-color: ${({ color }) => color}1A;
  margin-top: 8px;
`

const ScheduleListWrapper = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  margin: 0 16px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
`

const ScheduleListTitle = styled.div`
  background: #777777;
  color: #fff;
  width: fit-content;
  border-radius: 6px;
  padding: 0 6px;
`

const ScheduleListInput = styled.input`
  display: block;
  width: 94%;
  margin-top: 8px;
`

const ScheduleWrapper = styled.div`
  flex-grow: 1;
  overflow-y: scroll;
  padding-bottom: 8px;
`
